import { TFunction } from 'next-i18next';
import * as Yup from 'yup';

export class RestorePasswordForm {
  public email: string;

  constructor() {
    this.email = '';
  }

  public static getValidationSchema(t: TFunction): Yup.SchemaOf<RestorePasswordForm> {
    return Yup.object()
      .shape({
        email: Yup.string()
          .required(t('ERRORS.TEXT_EMAIL_REQUIRED'))
          .email(t('ERRORS.TEXT_EMAIL_INVALID'))
      });
  }
}
